export default __webpack_public_path__ + "d0618d625df174a94a9e0062d3e27675.png";